<template>
  <div id="footer" class="w-100">
    <div class="center container p-4">
      <div class="d-flex justify-content-between">
        <div class="fw-light">
          <NuxtLink to="/impressum">Impressum</NuxtLink>

          <div class="py-1">©2025 Voice Art Productions</div>
          <div>Datenschutz</div>
        </div>
        <div>
          <a href="https://wa.me/1622130932" target="_blank" class="">
            <svg
              viewBox="0 0 32 32"
              width="36"
              xmlns="http://www.w3.org/2000/svg"
            >
              <use fill="white" href="../assets/svg/whatsapp.svg#whatsapp" />
            </svg>
          </a>
          <a
            href="https://www.instagram.com/voice.art.productions/"
            target="_blank"
            class="px-3"
          >
            <svg
              viewBox="0 0 32 32"
              width="32"
              xmlns="http://www.w3.org/2000/svg"
              class="pt-2"
            >
              <use fill="white" href="../assets/svg/insta_logo.svg#instagram" />
            </svg>
          </a>
          <a
            href="https://www.linkedin.com/company/voice-art-productions/"
            target="_blank"
          >
            <svg
              viewBox="0 0 72 72"
              width="32"
              xmlns="http://www.w3.org/2000/svg"
            >
              <use fill="white" href="../assets/svg/linkedin.svg#linkedin" />
            </svg>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
#footer {
  background-color: black;
  color: rgb(210, 210, 210);
  padding-top: 1rem;
  padding-bottom: 1rem;
}

a {
  color: rgb(210, 210, 210);
}

svg {
  opacity: 0.66;
}

svg:hover {
  opacity: 1;
}
</style>
